import { bool, func, number, oneOfType, string, object } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from './actions';
import getters from './getters';

class Field extends Component {
  static propTypes = {
    blurField: func.isRequired,
    component: func.isRequired,
    destroyField: func.isRequired,
    focusField: func.isRequired,
    initializeField: func.isRequired,
    initialValue: oneOfType([string, number, bool]),
    isDirty: bool,
    isInValid: bool,
    isValid: bool,
    name: string.isRequired,
    path: string.isRequired,
    syncField: func.isRequired,
    type: string.isRequired,
    updateField: func.isRequired,
    validation: string,
    currentApplicant: object.isRequired, //eslint-disable-line
  };

  static defaultProps = {
    initialValue: '',
    isDirty: false,
    isInValid: true,
    isValid: false,
    validation: 'none',
  };

  constructor(props) {
    super(props);
    this.blur = this.blur.bind(this);
    this.focus = this.focus.bind(this);
    this.initialize = this.initialize.bind(this);
    this.sync = this.sync.bind(this);
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(props) {
    if (props.path !== this.props.path) this.initialize();
    else this.sync();
  }

  componentWillUnmount() {
    this.destroy();
  }

  initialize() {
    const {
      name,
      initialValue,
      initializeField,
      validation,
      type,
    } = this.props;
    initializeField({ name, initialValue, validation, type });
  }

  update({ target }) {
    const { updateField, type } = this.props;
    const value = type === 'checkbox' ? target.checked : target.value;
    updateField({ name: target.name, value });
  }

  destroy() {
    const { name, destroyField } = this.props;
    destroyField({ name });
  }

  sync() {
    const { validation, syncField, name, currentApplicant } = this.props;
    syncField({ validation, name, currentApplicant });
  }

  focus() {
    const { focusField, name } = this.props;
    focusField({ name });
  }

  blur() {
    const { blurField, name } = this.props;
    blurField({ name });
  }

  render() {
    const { component: C, initialValue, ...rest } = this.props;
    return (
      <div>
        <C
          onChange={this.update}
          onFocus={this.focus}
          onBlur={this.blur}
          {...rest}
        />
      </div>
    );
  }
}

function mapStateToProps({ form, router }, { name }) {
  return {
    path: router.location.pathname,
    error: getters.getError(form, name),
    isInValid: getters.isInValid(form, name),
    isDirty: getters.isDirty(form, name),
    isValid: getters.isValid(form, name),
    value: getters.getFieldValue(form, name),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    blurField: (field) => dispatch(actions.blurField(field)),
    focusField: (field) => dispatch(actions.focusField(field)),
    initializeField: (field) => dispatch(actions.initializeField(field)),
    syncField: (field) => dispatch(actions.syncField(field)),
    updateField: (field) => dispatch(actions.updateField(field)),
    destroyField: (field) => dispatch(actions.destroyField(field)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Field);



// WEBPACK FOOTER //
// ./src/features/Form/Field.js